export const termos = {
    PESQUISATIPOS: 'PESQUISATIPOS',
    NOVOATUALIZA: 'NOVOATUALIZA',
    PESQUISA: 'PESQUISA',
    RENDERIZAR: 'RENDERIZAR'
}